import {  DownloadOutlined, ExclamationCircleOutlined, ImportOutlined, InfoCircleOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Modal, Row, Space, Table, Tooltip, Upload, message } from "antd";
import React, { useState } from "react";
import * as XLSX from 'xlsx';
import '../../css/importexcel-page.css';
import LoadingBase from "../../components/LoadingBase";
import { useSelector } from "react-redux";
import { consoleLogUtil } from "../../utils/consoleLogUtil";
import { customers_import, products_import } from "../../services/apis";
import { getSelectedBranch } from "../../utils/funcHelper";
import { BASE_URL } from "../../settings/config";
import { DATE_FORMAT, HeaderTableCus } from "../../constants/constants";
import dayjs from "dayjs";

const ImportProductPage = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [isShowButton, setIsShowButton] = useState(false);
    const [modal, contextHolder] = Modal.useModal();
    const [loadingImport, setLoadingImport] = useState(false);
    const [mess, setMessage] = useState('');
    const [isShowModalMessage, setIsShowModalMessage] = useState(false);
    const userReducer = useSelector(state => state?.userReducer?.data);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên sản phẩm',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => <div>{text}</div>,
        },
        {
            title: 'Đơn vị',
            dataIndex: 'unit',
            key: 'unit',
            align: 'center',
            render: (text, record, index) => <div>{text}</div>,
        },
        {
            title: 'Giá nhập',
            dataIndex: 'cost_price',
            key: 'cost_price',
            align: 'center',
            render: (text, record, index) => (
                <span>{text ?? 0}</span>
            ),
        },
        {
            title: 'Giá bán',
            dataIndex: 'sell_price',
            key: 'sell_price',
            align: 'center',
            render: (text, record, index) => (
                <span>{text}</span>
            ),
        },
        
    ];



    const confirm = () => {
        
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: 'Bạn có chắc chắn muốn lưu thông tin sản phẩm không?',
            okText: 'Có',
            cancelText: 'Không',
            onOk: () => handleSaveInfo()
        });
    };

    const handleDownloadTemplate = () => {
        const link = BASE_URL + 'files/template_import_product.xlsx';
        window.open(link, '_blank');
    }

    const handleSaveInfo = async () => {
        const payload = {
            products: data
        };
        setLoading(true);
        const res = await products_import(payload);
        setLoading(false);
        if (res && res?.status === 1) {
            setMessage(`Hoàn thành import sản phẩm. Tổng: ${res?.data?.inserted} sản phẩm được thêm mới. ${res?.data?.failed} sản phẩm lỗi. ${res?.data?.skipped} sản phẩm bỏ qua do trùng tên.`);
            setIsShowModalMessage(true);
            setData([]);
            setIsShowButton(false);
        } else {
            message.warning(res?.msg ?? 'Import sản phẩm thất bại');
        }
    }
    const handleFileImport = async (dataImport) => {
        consoleLogUtil('dataImport', dataImport);
        const keys = ['name', 'unit', 'cost_price', 'sell_price'];
        // Duyệt qua các hàng để tạo mảng đối tượng
        const result = dataImport
        .filter((item, index) => index > 0 && item?.length > 0)
        .map(row => {
            return row.reduce((obj, value, index) => {
                const key = keys[index];
                obj[key] = value;
                return obj;
            }, {});
        });
        setData([...result]);
        setIsShowButton(true);
    }
    const props = {
        name: 'file',
        accept: '.xlsx,.xls',
        beforeUpload: (file) => {
            console.log('beforeUpload', file)
            setLoadingImport(true);
            let reader = new FileReader();
            reader.onload = function (e) {
                let data = e.target.result;
                let readedData = XLSX.read(data, { type: 'binary' });
                const wsname = readedData.SheetNames[0];
                const ws = readedData.Sheets[wsname];

                /* Convert array to json*/
                const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
                if (dataParse?.length > 1001) {
                    message.error("Không được vượt quá 1000 khách hàng trong 1 file");
                    setLoadingImport(false);
                    return;
                } else if (dataParse?.length > 0) {
                    handleFileImport(dataParse);
                } else {
                    message.error("Không tìm thấy khách hàng")
                }

                setLoadingImport(false);
            };
            reader.readAsBinaryString(file);
            return false;
        },
    };

    return (

        <div>
            {
                contextHolder
            }
            <Row className="row-button">
                <Upload {...props} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}>
                    <Tooltip title="Max upload 1000 orders/file">
                        <Button 
                            type="default" 
                            size="middle" block danger 
                            icon={<ImportOutlined />} 
                            disabled={loadingImport} 
                            onClick={() => { }}
                            style={{ paddingLeft: 10, paddingRight: 10 }}
                        >
                            Import Excel
                        </Button>
                    </Tooltip>
                </Upload>
                <Space>
                    <Button
                        type="primary"
                        size="middle"
                        block icon={<SaveOutlined />}
                        disabled={loading || !isShowButton}
                        onClick={confirm}
                        style={{ paddingLeft: 10, paddingRight: 10 }}
                    >
                        Lưu thông tin sản phẩm
                    </Button>
                    <Button
                        size="middle"
                        block icon={<DownloadOutlined />}
                        disabled={loading}
                        onClick={handleDownloadTemplate}
                        style={{ paddingLeft: 10, paddingRight: 10, background: 'green', color: 'white' }}
                    >
                        Dowload template
                    </Button>
                </Space>
                

            </Row>
            {
                data.length > 0 ?
                    <div>Total: {data.length} khách hàng</div> : null
            }

            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                style={{ marginTop: 20 }}
                rowClassName={() => 'custom-row'}
                scroll={{ x: 'max-content' }}
                pagination={{
                    showSizeChanger: true,
                    size: 'small'
                }}
                rowKey={(item) => item.phone?.toString()}
            />
            <LoadingBase loading={loading} />
            <Modal
                open={isShowModalMessage}
                centered
                footer={[
                    <Button key="submit" type="primary" onClick={() => setIsShowModalMessage(false)}>
                        Close
                    </Button>
                ]}
                closable={false}
            >
                <div>
                    <p className="title-notify">
                        <InfoCircleOutlined style={{
                            color: 'blue',
                        }} /> Thông báo</p>

                    <span>{mess}</span>

                </div>
            </Modal>
        </div>
    )
}

export default React.memo(ImportProductPage);
